// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"257989a7","513":"98cb57ff","703":"ad6b4bde","787":"eb026e06"}[chunkId] + ".chunk.js";
};